import { CouldNotParse } from 'components/ordering/checkout/payment-methods/payment-backend/could-not-parse.js'
import { is } from 'typia'
import { CSCMollieCreditCard, TrydentMollieCreditCardData } from './mollie-credit-card.js'


type TrydentMollieCreditCardResponse = {
  custom_description: string,
  mollie_data: TrydentMollieCreditCardData & { id: 'creditcard' }
}

export const parseMollieCreditcard = (value: unknown, selectedPaymentMethod: string): CSCMollieCreditCard | typeof CouldNotParse => {
  if (is<TrydentMollieCreditCardResponse>(value)) {
    const state = value.mollie_data.id === selectedPaymentMethod ? 'selected' : 'selectable'
    return new CSCMollieCreditCard(
      value.mollie_data,
      state,
      value.custom_description
    )
  }
  return CouldNotParse
}
